import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Page, Card, DataTable, AppProvider, Link, Button, ButtonGroup, ResourceList, ResourceItem } from '@shopify/polaris';
import translations from '@shopify/polaris/locales/es.json';
import axiosRails from '@utils/axios';

const propTypes = {
  warranties: PropTypes.array.isRequired,
};


class WarrantyIndexWrapper extends Component {
  constructor(props) {
    super(props);
    console.log(props);

    this.state = {
      defaultWarrantyId: props.defaultWarrantyId
    }
  }

  render() {
    const primaryAction =  { 
      content: I18n.t("actions.add_x", { x: I18n.t("activerecord.models.warranty.one") }),
      url: "/admin/warranties/new"
    }

    return (
      <div className="has-actions">
        <AppProvider i18n={translations}>
          <Page fullWidth title="Warranties List" primaryAction={primaryAction}>
          <hr/>
            <Card>
              <ResourceHeader />
              <ResourceList
                resourceName={{
                  singular: I18n.t("activerecord.models.warranty", { count: 1 }),
                  plural: I18n.t("activerecord.models.warranty", { count: 2 })
                }}
                items={this.props.warranties}
                renderItem={(item) => {
                  return(
                    <ResourceItem
                      id={ item.id }
                      url={ `/admin/warranties/${item.id}/edit` }
                      accessibilityLabel={`View Details for ${item.name}`}>
                      <div className="container-fluid p0">
                        <div className="row">
                          <div className="col-12 col-md-4">
                            <span>{ item.name }</span>
                          </div>
                          <div className="col-12 col-md-4">
                            <span>{ item.tag }</span>
                          </div>
                          {/* Currently defaultWarrantyId feature is "hidden" */}
                          <div className="col-12 col-md-4 hidden_i">
                            <a className="buttonAction Polaris-Button Polaris-Button--outline Polaris-Button--monochrome" 
                              href="#" data-id={item.id} rel="nofollow" onClick={this.handleSetDefault}>
                              { this.state.defaultWarrantyId === item.id ? 'Default Warranty' : 'Mark As Default' }
                            </a>
                          </div>
                        </div>
                      </div>
                    </ResourceItem>
                  )
                }}/>
            </Card>
          </Page>
        </AppProvider>

      </div>
    );
  }

  handleSetDefault = async (e) => {
    e.preventDefault();
    
    let res = await axiosRails.post('/admin/warranties/set-default', {
      default_warranty_id: parseInt( e.target.dataset.id )
    });

    alert(res.data.message);
    this.setState({ defaultWarrantyId: res.data.defaultWarrantyId });
  }
}

const ResourceHeader = () => {
  return(
    <div className="container-fluid pt15 pb15 resource-header">
      <div className="row">
        <div className="col-12 col-md-4">
          <span>{I18n.t("activerecord.attributes.warranty.name")}</span>
        </div>
        <div className="col-12 col-md-4">
          <span>{I18n.t("activerecord.attributes.warranty.tag")}</span>
        </div>
        <div className="col-12 col-md-4">
          
        </div>
      </div>
    </div>
  )
}


WarrantyIndexWrapper.propTypes = propTypes;


export default WarrantyIndexWrapper;
